@if (isInitialized && component) {
  <oe-flat-widget button [title]="component.alias" button
    [link]="'/device/' + edge.id + newNavigationUrlSegment + '/history/' + component.id + '/scheduleChart'" [icon]="{name:
    'oe-time-of-use', color:'normal'}">
    <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.STATE.DELAY_DISCHARGE' | translate"
      [value]="delayedActiveTimeOverPeriod | formatSecondsToDuration">
    </oe-flat-widget-line>
    <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.STATE.CHARGE_GRID' | translate"
      [value]="chargedConsumptionActiveTimeOverPeriod | formatSecondsToDuration">
    </oe-flat-widget-line>
  </oe-flat-widget>
}
